module.exports = __webpack_public_path__ + "static/img/ad-1.eb2ea04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ad-1.png
// module id = nLIZ
// module chunks = 0